import { useCallback, useRef, useState } from 'react';
import { useLocalStorage, useMedia } from 'react-use';
import { useDispatch, useSelector } from 'react-redux';
import { useCustomScrollToTop } from '@srcDS/utils/useCustomScrollToTop';
import { getCurrentLocale } from '@srcDS/utils/getCurrentLocale';
import { useGlobalSettings } from '@srcDS/utils/useGlobalSettings';
import { useForm } from 'react-hook-form';

export const useProductSelection = () => {
  const addToRef = useRef(null);

  const [findStoreTypeStorage] = useLocalStorage('findStoreType', '');
  const [findStoreType, setFindStoreType] = useState();

  const [selectedStore, setSelectedStore] = useLocalStorage('selectedStore');
  const [selectedStoreState, setSelectedStoreState] = useState(selectedStore);
  const [storeList, setStoreList] = useState(null);
  const [statusMenu, setStatusMenu] = useState({ status: false, label: false });
  const [activeTab, setActiveTab] = useState('reviews');

  const dispatch = useDispatch();
  const isMobile = useMedia('(max-width: 767px)', false);
  const { goToTop } = useCustomScrollToTop();

  const currentSiteRegion = getCurrentLocale();
  const state = useSelector((state) => state['demo-saba']);

  const { shouldHideClickCollect } = useGlobalSettings({
    locale: currentSiteRegion,
  });

  const { register, getValues, setValue, watch } = useForm({
    mode: 'all',
    defaultValues: {
      qty: 1,
    },
  });
  const selectedQty = watch('qty');

  const setShowDialog = useCallback(() => {
    dispatch({ type: 'close-storelocator' });
  }, [dispatch]);

  const handleSetSelectedStore = useCallback((store) => {
    setSelectedStore(store);
    setSelectedStoreState(store);
  }, []);

  return {
    findStoreTypeStorage,
    findStoreType,
    setFindStoreType,
    selectedStore,
    selectedStoreState,
    storeList,
    setStoreList,
    statusMenu,
    setStatusMenu,
    activeTab,
    setActiveTab,
    addToRef,
    dispatch,
    isMobile,
    goToTop,
    currentSiteRegion,
    state,
    shouldHideClickCollect,
    register,
    getValues,
    setValue,
    selectedQty,
    setShowDialog,
    handleSetSelectedStore
  };
};
